<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <FormItem label="设备类型" v-if="comType!='admin'">
        <Select
          v-model="searchCondition.device_type"
          placeholder="请选择"
          style="width: 300px;"
          clearable
        >
          <Option v-for="(item,index) in deviseType" :key="index" :value="item.key">{{item.value}}</Option>
        </Select>
      </FormItem>
      <Form-item label="用户名称" :label-width="70">
        <Input
          style="width:260px"
          placeholder="请输入用户名关键字"
          v-model="searchCondition.name"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </Form-item>
      <Form-item label="开始时间">
        <DatePicker
          :editable="false"
          type="datetime"
          v-model="loginStart"
          split-panels
          placeholder="开始时间"
          format="yyyy-MM-dd HH:mm"
          @on-change="onStart"
          style="width: 200px"
        ></DatePicker>
      </Form-item>
      <Form-item label="结束时间">
        <DatePicker
          :editable="false"
          type="datetime"
          v-model="loginEnd"
          split-panels
          placeholder="结束时间"
          format="yyyy-MM-dd HH:mm"
          @on-change="onEnd"
          style="width: 200px"
        ></DatePicker>
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="column"
        :data-url="dataUrl"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        selectType="none"
      ></Grid>
    </div>
  </div>
</template>

<script>
import { Terminal } from "../../utils/enums";
export default {
  name: "Record",
  props: {
    selectType: {
      type: String,
      default: "multi"
    },
    dataUrl: {
      type: String
    },
    comType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      column: [
        {
          title: "用户名称",
          key: "name",
          minWidth: 130
        },
        {
          title: "登录时间",
          key: "login_time",
          align: "center",
          minWidth: 160
        },
        {
          title: "设备类型",
          key: "deviseType",
          align: "center",
          minWidth: 120
        },
        {
          title: "登录IP",
          key: "login_ip",
          align: "center",
          minWidth: 150
        }
      ],
      loginStart: "",
      loginEnd: "",
      selectList: [],
      searchCondition: {
        device_type: "",
        name: "",
        login_start: "",
        login_end: "",
        init: function() {
          this.device_type = "";
          this.name = "";
          this.login_start = "";
          this.login_end = "";
        }
      },
      deviseType: Terminal.getOptions()
    };
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(row => {
        row.login_time = this.$pub.timestampToTime(row.login_time);
        row.deviseType = Terminal.getValue(row.device_type);
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.init();
        this.loginStart = "";
        this.loginEnd = "";
        this.$refs.grid.searchRefresh();
      }
      if (this.comType) this.searchCondition.device_type = "";
      this.$refs.grid.searchRefresh();
    },
    onStart(range) {
      this.searchCondition.login_start = range;
    },
    onEnd(range) {
      this.searchCondition.login_end = range;
    }
  }
};
</script>

<style scoped>
</style>
